import { render } from "./ActivityIcon.vue?vue&type=template&id=4227b07d"
const script = {}
script.render = render

export default script